import { EMPTY, Observable } from "rxjs"
import { switchMap } from "rxjs/operators"
import { ofType, StateObservable } from "redux-observable"
import type { EpicDependencies } from "../rxjs/configureEpics"
import { RIGHT_MODAL_CLOSE_CLICKED } from "./actions"
import { getCurrentPath } from "./selectors"
import { closeModifierGroupFormClicked } from "../screens/categories/modifierGroups/actions"
import { closeOptionGroupFormClicked } from "../screens/categories/optionGroups/actions"
import { closeModifierFormClicked } from "../screens/categories/modifiers/actions"
import { closeInventoryStockingFormClicked } from "../screens/inventory/actions"
import { Action, StateObject } from "../redux/types"

// todo:
// This epic is hackish as hell.
// We should remove this and resolve this via some callback props of <Drawer /> 'onClose' or something.
export const modalClosedEpics = (
    actions$: Observable<Action>,
    _state$: StateObservable<StateObject>,
    deps: EpicDependencies
) =>
    actions$.pipe(
        ofType(RIGHT_MODAL_CLOSE_CLICKED),
        switchMap((action: Action) => {
            const router = action.payload.router
            const pathInfo = getCurrentPath(deps.getState())
            const actualPath = pathInfo.asPath || ""
            const urlQuery = pathInfo.query

            // Inventory stocking modal
            if (urlQuery.agenda === "inventory" && !!urlQuery.locationId) {
                return [closeInventoryStockingFormClicked()]
            }

            if (
                (urlQuery.tab === "categories" || urlQuery.tab === "schematized") &&
                urlQuery.id &&
                urlQuery.modal === "add-modifier-group"
            ) {
                return [closeModifierGroupFormClicked()]
            }

            if (
                (urlQuery.tab === "categories" || urlQuery.tab === "schematized") &&
                urlQuery.id &&
                urlQuery.modal === "add-option"
            ) {
                return [closeOptionGroupFormClicked()]
            }

            if (urlQuery.tab === "modifier-groups" && urlQuery.id && urlQuery.modal === "add-modifier") {
                return [closeModifierFormClicked()]
            }

            // Exit from Kiosk images
            if (
                urlQuery.agenda === "locations" &&
                urlQuery.id &&
                urlQuery.modal === "terminal" &&
                urlQuery.screen === "images"
            ) {
                router.push(`/locations/edit/terminal/${urlQuery.id}`)
                return []
            }

            // Exit from Taxation add items
            if (urlQuery.agenda === "taxation" && urlQuery.locationId) {
                if (urlQuery.add) {
                    router.push(`/taxation/add/${urlQuery.add}`)
                } else if (urlQuery.id) {
                    router.push(`/taxation/edit/${urlQuery.id}`)
                }
                return []
            }

            if (actualPath.includes("/menu/categories")) {
                router.push("/menu/categories")
            } else if (actualPath.includes("/menu/option-groups")) {
                router.push("/menu/option-groups")
            } else if (actualPath.includes("/menu/modifiers")) {
                router.push("/menu/modifiers")
            } else if (actualPath.includes("/inventory")) {
                router.push("/inventory")
            } else if (actualPath.includes("/menu/modifier-groups")) {
                router.push("/menu/modifier-groups")
            } else if (actualPath.includes("/taxation-old")) {
                router.push("/taxation-old")
            } else if (actualPath.includes("/taxation")) {
                router.push("/taxation")
            } else if (actualPath.includes("/domains")) {
                router.push("/domains")
            } else if (actualPath.includes("/sales-input/schematized")) {
                router.push("/sales-input/schematized")
            } else if (actualPath.includes("/make-it-butter-settings")) {
                router.push("/make-it-butter-settings")
            } else if (actualPath.includes("/delivery-settings")) {
                router.push("/delivery-settings")
            } else if (actualPath.includes("/assignments")) {
                router.push("/assignments")
            } else if (actualPath.includes("/locations")) {
                router.push("/locations")
            } else if (actualPath.includes("/pricing")) {
                router.push("/pricing")
            } else if (actualPath.includes("/promotions")) {
                router.push("/promotions")
            } else if (actualPath.includes("/card-programs/programs")) {
                router.push("/card-programs/programs")
            } else if (urlQuery.agenda === "orders" && !!urlQuery.cardId) {
                router.push(`/reports/orders/orders/edit/${urlQuery.id}`)
            } else if (actualPath.includes("/card-programs/cards")) {
                router.push("/card-programs/cards")
            }
            // Customers agenda
            else if (urlQuery.agenda === "customers" && urlQuery.id && urlQuery.orderId) {
                router.push(`/reports/customers/edit/${urlQuery.id}`)
            } else if (urlQuery.agenda === "customers" && urlQuery.tab === "google-reviews") {
                router.push("/reports/customers/google-reviews")
            } else if (urlQuery.agenda === "customers" && urlQuery.tab === "feedback") {
                router.push("/reports/customers/feedback")
            } else if (urlQuery.agenda === "customers") {
                router.push("/reports/customers")
            } // Orders agenda
            else if (actualPath.includes("/reports/orders")) {
                const { id: _id, ...otherQueryParams } = router.query
                router.push({
                    pathname: "/reports/orders/orders",
                    query: otherQueryParams,
                })
            } else if (actualPath.includes("/employees/table")) {
                router.push("/employees/table")
            } else if (actualPath.includes("/employees/roles")) {
                router.push("/employees/roles")
            } else if (actualPath.includes("/employees/positions")) {
                router.push("/employees/positions")
            } else if (actualPath.includes("/sales-input/butter")) {
                router.push("/sales-input/butter")
            } else if (actualPath.includes("/sales-input/kiosk")) {
                router.push("/sales-input/kiosk")
            }

            return EMPTY
        })
    )
export default [modalClosedEpics]
